import { styled } from 'styled-components';
export const PlayLayoutContainer = styled.div.withConfig({
  displayName: "PlayLayoutContainer",
  componentId: "sc-1n9bx27-0"
})(["min-height:100vh;display:flex;flex-direction:column;"]);